import { BrowserRouter, Routes, Route, Link, Switch, Outlet } from 'react-router-dom'
import pages from '../../components/pages';
import Header from '../../components/shared/header/Header';
import React from "react";
import Home from '../../components/pages/home/Home';
import FallBack from '../../components/pages/fallback/FallBack'
import './route.scss';
const routes = [
    {
        path: 'index.html',
        component: pages.Loader,
    },
    {
        path: '/',
        component: pages.Loader
    },
    {
        path: '/home',
        component: pages.Home
    },
    {
        path: '/result',
        component: pages.Result,
    },
    {
        path: '/fallback',
        component: pages.FallBack,
    }
]


const AppRoute = () => {

    const Layout = () => {
        return (
            <div className='router-outlet'>
                <div className='outlet' >
                    <Outlet />
                </div>
            </div>
        );
    };

    return (

        <BrowserRouter basename={process.env.REACT_APP_PUBLIC_URL} >
            <Routes>
                <Route path='/' element={<Layout />}>
                    {routes.map((page) => (
                        <Route key={page.path} path={page.path} element={<page.component />} />
                    ))}
                </Route>
            </Routes>
        </BrowserRouter>

    );
}

export default AppRoute;